module.exports = __webpack_public_path__ + "static/media/adela-kontakt.01efccd9.jpg";